/* ==========================================================================
   Produktový kupon „Koupit s kódem" (styl Alza, markup snippets/tk-coupon.liquid)

   [data-tk-coupon-open]   pruh na kartě / PDP / sticky liště: otevře okno s
                           vysvětlením a tlačítkem „Koupit s kódem"; to přidá
                           variantu do košíku + uplatní kód. Karta s víc
                           variantami (data-mode="choose") vede z okna na detail.
   [data-tk-coupon-apply]  košík: uplatní kód k položce, která už v košíku je
   [data-tk-coupon-ends]   po konci akce prvek zmizí (stránka mohla být v cache
                           Shopify déle, než akce běžela)

   Kód se uplatňuje přes POST /cart/update.js { discount: "A,B" } — stejně jako
   pole na slevový kód v košíku (assets/cart-discount.js). Posílá se VŽDY
   i seznam kódů, které už v košíku jsou, jinak by je Shopify zahodil.
   Žádné přesměrování přes /discount/KÓD, drawer se otevře a překreslí hned.

   🔴 KONFLIKT KÓDŮ: kupon se nesčítá se slevami na celý košík (MO10, uvítací…).
   Shopify pak z nesčitatelných kódů nechá ten VÝHODNĚJŠÍ a druhý označí
   `applicable: false` — bez hlášky, zákazník by viděl, že se „nic nestalo".
   Proto se po uplatnění porovná stav kódů před a po:
     - náš kód neplatí a jiný ano  → okno „Ponechat MO10 / Přesto použít KÓD"
     - náš kód platí, jiný vypadl → okno s vysvětlením, že MO10 vypadl
   „Ponechat" kód z košíku odebere a výzvu u produktu skryje (sessionStorage).

   Události: cart:add:initiate / cart:update (drawer, počítadlo, GTM add_to_cart
   v tk-track.js přes source 'product-form-component'), tk:coupon (GTM
   coupon_applied / coupon_error, detail.source = 'product_coupon').
   ========================================================================== */
(function () {
  if (window.__tkCouponInit) return;
  window.__tkCouponInit = true;

  var L = window.__tkCouponLabels || {};
  var DISMISS_KEY = 'tk_coupon_dismissed';

  function routes() {
    var r = (window.Theme && window.Theme.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      add: (r.cart_add_url || root + 'cart/add') + '.js',
      update: (r.cart_update_url || root + 'cart/update') + '.js',
      cart: (r.cart_url || root + 'cart') + '.js',
    };
  }

  function stripJs(u) {
    return u.replace(/\.js\.js$/, '.js');
  }

  function same(a, b) {
    return String(a || '').toUpperCase() === String(b || '').toUpperCase();
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    });
    return ids;
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function fill(tpl, map) {
    var out = String(tpl || '');
    Object.keys(map).forEach(function (k) { out = out.split(k).join(map[k]); });
    return out;
  }

  function postJson(url, body) {
    return fetch(stripJs(url), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    });
  }

  /* Kódy v košíku i s tím, jestli teď platí: [{code, applicable}] */
  function currentCodes() {
    return fetch(stripJs(routes().cart), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return (cart.discount_codes || []).filter(function (d) { return d && d.code; }); })
      .catch(function () { return []; })
      .then(function (list) {
        document.querySelectorAll('.cart-discount__pill[data-discount-code]').forEach(function (el) {
          var c = el.getAttribute('data-discount-code');
          if (c && !list.some(function (d) { return same(d.code, c); })) list.push({ code: c, applicable: true });
        });
        return list;
      });
  }

  function setCodes(codes, sectionIds) {
    var body = { discount: codes.join(',') };
    if (sectionIds && sectionIds.length) body.sections = sectionIds;
    return postJson(routes().update, body);
  }

  /* Uplatní kód a vrátí, co se stalo:
     ok      = náš kód platí
     blocked = kódy, které platí místo našeho (náš neplatí)
     lost    = kódy, které platily a kvůli našemu vypadly */
  function applyCode(code, sectionIds) {
    var before = [];
    return currentCodes().then(function (list) {
      before = list;
      var codes = list.map(function (d) { return d.code; });
      if (!codes.some(function (c) { return same(c, code); })) codes.push(code);
      return setCodes(codes, sectionIds);
    }).then(function (res) {
      var after = (res.data && res.data.discount_codes) || [];
      var hit = after.filter(function (d) { return same(d.code, code); })[0];
      var ok = !!(res.ok && hit && hit.applicable !== false);
      var others = after.filter(function (d) { return !same(d.code, code); });
      var blocked = ok ? [] : others.filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; });
      var lost = !ok ? [] : others.filter(function (d) {
        if (d.applicable !== false) return false;
        var prev = before.filter(function (b) { return same(b.code, d.code); })[0];
        return prev && prev.applicable !== false;
      }).map(function (d) { return d.code; });
      return { ok: ok, blocked: blocked, lost: lost, data: res.data || {} };
    });
  }

  function emitCoupon(status, code, reason) {
    document.dispatchEvent(new CustomEvent('tk:coupon', {
      detail: { status: status, code: code, reason: reason || '', source: 'product_coupon' },
    }));
  }

  function refreshCart(el, data, extra) {
    var d = { sections: data.sections || {}, source: 'tk-coupon', itemCount: data.item_count };
    if (extra) Object.keys(extra).forEach(function (k) { d[k] = extra[k]; });
    (el || document).dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true, composed: true,
      detail: { resource: {}, sourceId: 'tk-coupon', data: d },
    }));
  }

  /* ---------- Skryté výzvy („Ponechat MO10") ---------- */
  function dismissed() {
    try { return JSON.parse(sessionStorage.getItem(DISMISS_KEY) || '[]'); } catch (e) { return []; }
  }

  function applyDismissStyle() {
    var list = dismissed();
    var st = document.getElementById('tk-coupon-dismissed');
    if (!list.length) { if (st) st.remove(); return; }
    if (!st) {
      st = document.createElement('style');
      st.id = 'tk-coupon-dismissed';
      document.head.appendChild(st);
    }
    /* <style> přežije morph košíku, výzva se nevrátí po každém překreslení */
    st.textContent = list.map(function (c) {
      return '.tk-coupon--cart[data-code="' + String(c).replace(/["\\]/g, '') + '"]{display:none!important}';
    }).join('');
  }

  function dismiss(code) {
    var list = dismissed();
    if (!list.some(function (c) { return same(c, code); })) list.push(code);
    try { sessionStorage.setItem(DISMISS_KEY, JSON.stringify(list)); } catch (e) {}
    applyDismissStyle();
  }

  function undismiss(code) {
    var list = dismissed().filter(function (c) { return !same(c, code); });
    try { sessionStorage.setItem(DISMISS_KEY, JSON.stringify(list)); } catch (e) {}
    applyDismissStyle();
  }

  /* ---------- Okno (Alza styl): obecné ---------- */
  var modal = null;

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('dialog');
    modal.className = 'tk-coupon-modal';
    modal.setAttribute('aria-labelledby', 'tk-coupon-modal-text');
    modal.innerHTML =
      '<button type="button" class="tk-coupon-modal__close" data-tk-coupon-close aria-label="' + esc(L.close || 'Zavřít') + '">' +
      '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<p class="tk-coupon-modal__text" id="tk-coupon-modal-text"></p>' +
      '<p class="tk-coupon-modal__valid" hidden></p>' +
      '<div class="tk-coupon-modal__actions"></div>';
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.body.appendChild(modal);
    return modal;
  }

  /* opts: { html, valid, primary: {label, run}, secondary: {label, run} } */
  function showDialog(opts) {
    var m = buildModal();
    m.querySelector('.tk-coupon-modal__text').innerHTML = opts.html || '';
    var valid = m.querySelector('.tk-coupon-modal__valid');
    valid.textContent = opts.valid || '';
    valid.hidden = !opts.valid;
    var box = m.querySelector('.tk-coupon-modal__actions');
    box.innerHTML = '';
    function add(cfg, cls) {
      if (!cfg) return null;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.textContent = cfg.label;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
        if (cfg.run) cfg.run();
      });
      box.appendChild(b);
      return b;
    }
    var first = add(opts.primary, 'button tk-coupon-modal__cta');
    add(opts.secondary, 'tk-coupon-modal__alt');
    if (typeof m.showModal === 'function') {
      if (!m.open) m.showModal();
    } else m.setAttribute('open', '');
    if (first) first.focus();
  }

  function closeModal() {
    if (!modal) return;
    if (typeof modal.close === 'function' && modal.open) modal.close();
    else modal.removeAttribute('open');
  }

  function message(text) {
    showDialog({ html: esc(text), primary: { label: L.ok || 'OK' } });
  }

  function codesHtml(list) {
    return list.map(function (c) { return '<strong>' + esc(c) + '</strong>'; }).join(', ');
  }

  /* Výsledek uplatnění → případné okno. `el` = prvek, ze kterého se překreslí košík. */
  function resolveOutcome(code, r, el) {
    if (r.ok) {
      emitCoupon('applied', code);
      undismiss(code);
      if (r.lost.length) {
        showDialog({
          html: fill(L.lostHtml, { __CODE__: '<strong>' + esc(code) + '</strong>', __OTHER__: codesHtml(r.lost) }),
          primary: { label: L.ok || 'OK' },
        });
      }
      return;
    }
    emitCoupon('error', code, r.blocked.length ? 'not_combinable' : 'not_applicable');
    if (!r.blocked.length) {
      message(L.applyError || 'Kód se nepodařilo uplatnit.');
      return;
    }
    var other = r.blocked.join(', ');
    showDialog({
      html: fill(L.conflictHtml, { __CODE__: '<strong>' + esc(code) + '</strong>', __OTHER__: codesHtml(r.blocked) }),
      primary: {
        label: fill(L.keep, { __OTHER__: other }),
        run: function () {
          /* Náš kód z košíku pryč (ať tam nevisí neplatný) + výzvu skrýt */
          dismiss(code);
          currentCodes().then(function (list) {
            var keep = list.map(function (d) { return d.code; }).filter(function (c) { return !same(c, code); });
            return setCodes(keep, cartSectionIds());
          }).then(function (res) { refreshCart(el, res.data || {}); });
        },
      },
      secondary: {
        label: fill(L.force, { __CODE__: code }),
        run: function () {
          /* Blokující kódy pryč, náš zůstane → Shopify ho uplatní */
          currentCodes().then(function (list) {
            var keep = list.map(function (d) { return d.code; }).filter(function (c) {
              return !r.blocked.some(function (b) { return same(b, c); });
            });
            if (!keep.some(function (c) { return same(c, code); })) keep.push(code);
            return setCodes(keep, cartSectionIds());
          }).then(function (res) {
            refreshCart(el, res.data || {});
            var hit = ((res.data && res.data.discount_codes) || []).filter(function (d) { return same(d.code, code); })[0];
            if (hit && hit.applicable !== false) emitCoupon('applied', code);
            else message(L.applyError || 'Kód se nepodařilo uplatnit.');
          });
        },
      },
    });
  }

  /* ---------- Karta: variantu bere z karty (swatch mohl přepnout) ---------- */
  function resolveVariant(el) {
    var card = el.closest('product-card');
    var api = window.tkCard;
    /* Víc variant bez vybrané barvy na kartě = na detail (tam se vybírá) */
    if (el.getAttribute('data-mode') === 'choose') {
      if (card && api && api.mode && api.mode(card) === 'add' && api.variantId) {
        var picked = api.variantId(card);
        if (picked) return String(picked);
      }
      return null;
    }
    if (card && api && api.variantId) {
      var vid = api.variantId(card);
      if (vid) return String(vid);
    }
    return el.getAttribute('data-variant-id');
  }

  function addWithCode(el) {
    if (el.dataset.tkBusy === '1') return;
    var code = el.getAttribute('data-code');
    var vid = el.classList.contains('tk-coupon--card') ? resolveVariant(el) : el.getAttribute('data-variant-id');
    if (!code) return;
    if (!vid) {
      var url = el.getAttribute('data-product-url');
      if (url) window.location.href = url + '#tk-coupon';
      return;
    }

    var productId = el.getAttribute('data-product-id') || '';
    el.dataset.tkBusy = '1';
    el.classList.add('is-loading');

    /* Optimisticky: drawer se začne otevírat, bublina košíku přičte */
    el.dispatchEvent(new CustomEvent('cart:add:initiate', { bubbles: true, composed: true, detail: { quantity: 1 } }));

    function fail(msg) {
      el.dataset.tkBusy = '';
      el.classList.remove('is-loading');
      el.dispatchEvent(new CustomEvent('cart:add:revert', { bubbles: true, composed: true, detail: { quantity: 1 } }));
      el.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true, composed: true,
        detail: { resource: {}, sourceId: 'tk-coupon', data: { didError: true, source: 'tk-coupon', itemCount: 1, productId: productId } },
      }));
      message(msg || L.addError || 'Produkt se nepodařilo přidat do košíku.');
    }

    postJson(routes().add, { items: [{ id: Number(vid), quantity: 1 }] })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          fail(res.data && (res.data.description || res.data.message));
          return;
        }
        return applyCode(code, cartSectionIds()).then(function (r) {
          el.dataset.tkBusy = '';
          el.classList.remove('is-loading');
          /* source product-form-component = drawer se otevře, bublina přičte 1, GTM add_to_cart */
          refreshCart(el, r.data, { source: 'product-form-component', itemCount: 1, productId: productId });
          resolveOutcome(code, r, el);
        });
      })
      .catch(function (err) {
        if (window.console) console.error('[tk-coupon]', err);
        fail();
      });
  }

  function applyFromCart(btn) {
    if (btn.dataset.tkBusy === '1') return;
    var code = btn.getAttribute('data-code');
    if (!code) return;
    btn.dataset.tkBusy = '1';
    btn.classList.add('is-loading');
    applyCode(code, cartSectionIds())
      .then(function (r) {
        btn.dataset.tkBusy = '';
        btn.classList.remove('is-loading');
        /* Překreslí položky košíku (drawer i /cart) */
        refreshCart(btn, r.data);
        resolveOutcome(code, r, btn);
      })
      .catch(function () {
        btn.dataset.tkBusy = '';
        btn.classList.remove('is-loading');
        message(L.applyError || 'Kód se nepodařilo uplatnit.');
      });
  }

  /* ---------- Okno „Koupit s kódem" (jako Alza) ---------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function fmtLeft(sec) {
    var d = Math.floor(sec / 86400);
    var h = Math.floor((sec % 86400) / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var u = L.units || { d: 'd', h: 'h', m: 'min' };
    if (d > 0) return d + '\u00a0' + u.d + ' ' + h + '\u00a0' + u.h;
    if (h > 0) return h + '\u00a0' + u.h + ' ' + pad(m) + '\u00a0' + u.m;
    return Math.max(m, 1) + '\u00a0' + u.m;
  }

  function openOffer(src) {
    var code = src.getAttribute('data-code') || '';
    var offer = src.getAttribute('data-offer') || '';
    var end = Number(src.getAttribute('data-tk-coupon-ends')) || 0;
    var left = end - Date.now() / 1000;
    var valid = '';
    if (end > 0 && left > 0 && left <= 72 * 3600 && L.endsIn) valid = L.endsIn.replace('__T__', fmtLeft(left));
    else if (src.getAttribute('data-until') && L.validUntil) valid = L.validUntil.replace('__D__', src.getAttribute('data-until'));
    showDialog({
      html: fill(L.modalText || 'Získejte slevu __OFFER__ s kódem __CODE__.', { __OFFER__: esc(offer), __CODE__: esc(code) }),
      valid: valid,
      primary: { label: L.modalCta || 'Koupit s kódem', run: function () { addWithCode(src); } },
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-tk-coupon-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }

    var apply = t.closest('[data-tk-coupon-apply]');
    if (apply) {
      e.preventDefault();
      applyFromCart(apply);
      return;
    }

    var open = t.closest('[data-tk-coupon-open]');
    if (!open) return;
    /* Cmd/Ctrl/prostřední tlačítko na odkazu karty = otevřít detail v nové záložce */
    if (open.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) return;
    e.preventDefault();
    e.stopPropagation();
    openOffer(open);
  }, true);

  /* ---------- Konec akce ---------- */
  function tick() {
    var now = Date.now() / 1000;
    document.querySelectorAll('[data-tk-coupon-ends]').forEach(function (el) {
      var end = Number(el.getAttribute('data-tk-coupon-ends')) || 0;
      if (end > 0 && now >= end) el.remove();
    });
  }

  /* ---------- Příchod z karty přes #tk-coupon: zvýrazni pruh ---------- */
  function flashFromHash() {
    if (window.location.hash !== '#tk-coupon') return;
    var el = document.getElementById('tk-coupon');
    if (!el) return;
    el.classList.add('is-flash');
    setTimeout(function () { el.classList.remove('is-flash'); }, 1500);
  }

  function boot() {
    applyDismissStyle();
    tick();
    flashFromHash();
    setInterval(tick, 30000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
